import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

export const checkNewHardwarePageFeatureFlag: HermesGuardFn = async (to) => {
  if (to.name !== 'brand.hardware' && to.name !== 'brand.hardware.store')
    return undefined
  if (useFeatureFlags().isEnabled('hermes.newHardwarePage')) return undefined
  return { name: 'brand.home', params: { brandId: to.params.brandId } }
}
